(ns app.front.view.group.admin.inspections.subs
  (:require [app.domain.group.model :as group-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.set :as set]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::inspector-groups
  :<- [::entities/context]
  :<- [::gas/group-id]
  (fn [[ctx group-id] _]
    (->> group-id
         (entities/find-children-recursive ctx)
         (filter inspection-model/inspector-group?))))

(rf/reg-sub ::use-qualifications?
  :<- [::gas/group-permit-types]
  (fn [permit-types _]
    (-> permit-types
        (set/intersection ptc-model/permit-types-with-qualifications)
        seq
        boolean)))

(rf/reg-sub ::enabled-qualifications
  :<- [::inspector-groups]
  :-> inspection-model/inspector-qualifications)



(rf/reg-sub ::visit-type-entities
  (fn [[_ group-id _]]
    [(rf/subscribe [::entities/entities {:entity/type            :entity.type/visit-type
                                         :domain/authority-group group-id}])
     (rf/subscribe [:language])])
  (fn [[results lang]]
    (->> (filter du/is-active? results)
         (sort-by :inspection-visit-type/names (i18n-model/localized-string-comparator lang)))))

(rf/reg-sub ::visit-result-entities
  :<- [::gas/group-id]
  :<- [::entities/context]
  :<- [:language]
  (fn [[group-id ctx lang]]
    (->> (entities/find-entities ctx {:entity/type            :entity.type/visit-result
                                      :domain/authority-group group-id})
         (filter du/is-active?)
         (sort-by :inspection-visit-result/names (i18n-model/localized-string-comparator lang)))))

(rf/reg-sub ::quick-pass-applicable-visit-results
  :<- [::visit-result-entities]
  (fn [results]
    (filter inspection-model/quick-pass-applicable-result? results)))

(rf/reg-sub ::visit-configuration-enabled?
  :<- [::ff/enabled? :feature-flag.id/inspection-visit-configuration]
  :<- [::ff/enabled? :feature-flag.id/inspection-visit-configuration-mobile]
  :<- [::gas/has-feature? :group.feature/mobile-app]
  group-model/has-mobile-feature?)

(rf/reg-sub ::inspection-dependencies
  (fn [[_ template-kind-id]]
    (rf/subscribe [::entities/entity template-kind-id]))
  :-> :inspection.template.kind/dependencies)
